export const LABELS_EQUIPMENT = {
	connected: "Підключені",
	registry: "Реєстр",
	instruction: "Інструкція",
	routerSetup: "Налаштування роутера",
	addMikrotik: "Додати MikroTik",
}
